export default function pageIdentify() {
  let url = window.location.pathname;
  url = url.split('/');
  url = url.find((ii) => (parseInt(ii) ? true : false));
  if (url) return true;
  else return false;
}
